import { useEffect, useState } from "react";
import "../styles/AdaptiveForm.css";
import { useNavigate } from "react-router-dom";
import axiosClient from "../api/axiosClient";
import AdaptiveRule from "../Components/AdaptiveRule";

export default function AdaptiveForm() {
  const [topics, setTopics] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState(true);
  const [showAll, setShowAll] = useState(false);

   const navigate = useNavigate();

  const [showRules, setShowRules] = useState(false);

  const handleStart = () => {
    setShowRules(true);
  };

  const handleContinue = () => {
    navigate("/adaptive", {
      state: {
        topic: selectedTopic,
      },
    });
  };

  useEffect(() => {
    fetchTopics();
  }, []);

  const fetchTopics = async () => {
    try {
      
const token = localStorage.getItem("token");

      const res = await axiosClient.get("/auth/adaptiveTopicName",
        {
          headers:{
            Authorization: `${token}`
          }
        }
      );

      console.log(res.data);

      setTopics(res.data.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const visibleTopics = showAll ? topics : topics.slice(0, 4);

  return (
    <div className="ts-page">
      <div className="ts-noise" />

      <div className="ts-card">
        <div className="ts-trophy-wrap">
          <div className="ts-trophy-ring ts-ring-3" />
          <div className="ts-trophy-ring ts-ring-2" />
          <div className="ts-trophy-ring ts-ring-1" />

          <div className="ts-trophy-icon">
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M6 9H4a2 2 0 0 1-2-2V5h4" />
              <path d="M18 9h2a2 2 0 0 0 2-2V5h-4" />
              <path d="M12 17v4" />
              <path d="M8 21h8" />
              <path d="M6 5h12v5a6 6 0 0 1-12 0V5z" />
            </svg>
          </div>
        </div>

        <h1 className="ts-heading">Technical Assessment Portal</h1>

        <p className="ts-subheading">
          Select your topic to generate a customized adaptive quiz
        </p>

        <div className="ts-section-label">
          <span className="ts-dot" />
          Choose any One Topic
        </div>

        <div className="ts-chips-grid">
          {visibleTopics.map((topic) => (
            <button
              key={topic}
              className={`ts-chip ${
                selectedTopic === topic ? "ts-chip--active" : ""
              }`}
              onClick={() => setSelectedTopic(topic)}
            >
              {selectedTopic === topic && (
                <span className="ts-chip-check">
                  <svg
                    width="11"
                    height="11"
                    viewBox="0 0 12 12"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="2,6 5,9 10,3" />
                  </svg>
                </span>
              )}
              {topic}
            </button>
          ))}
        </div>

        {/* 🔥 SEE MORE */}
        {topics.length > 4 && (
          <button
            className="ts-see-more"
            onClick={() => setShowAll(!showAll)}>
            {showAll ? "Show Less" : "See More"}
          </button>
        )}

        {selectedTopic && (
          <p className="ts-selected-hint">
            Selected Topic : <strong>{selectedTopic}</strong>
          </p>
        )}

         <button
        onClick={handleStart}
        className={`ts-start-btn ${
          !selectedTopic ? "ts-start-btn--disabled" : ""
        }`}
        disabled={!selectedTopic}
      >
        <span className="ts-start-btn__icon">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <polygon points="5,3 19,12 5,21" />
          </svg>
        </span>

        START ADAPTIVE TEST NOW
      </button>

      {showRules && (
        <AdaptiveRule
          onClose={() => setShowRules(false)}
          onContinue={handleContinue}
        />
      )}
      </div>
    </div>
  );
}